module.exports = __webpack_public_path__ + "img/righthua_white.28fbbaba.svg";